import { AxiosError } from 'axios';
import { ApiError } from 'services/api.errors';

export const protectApiError = (error: any): error is AxiosError<ApiError> =>
  error?.response?.headers['content-type'].includes('application/json') &&
  !!(error?.response?.data && 'code' in error.response.data);
